import axios from 'axios'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

const serverPost = (irl, username, password, data, handleReply) => {
    const url = irl.slice(0,4).toLowerCase().localeCompare('http')===0?irl:apiBaseUrl + irl
    //alert('serverPost url:' + url + ' data:' + JSON.stringify(data))
    axios.post(url, data, {auth: {username, password}})
    .then(response => {
        if (response.status === 200) {
            if (response.data.status) {
                if (response.data.status ==='OK') {
                    // handleStatus(STATUS_OK, 'OK: database modified successfully (response.data.status=' + response.data.status + 'JSON:'+ JSON.stringify(response.data) + ')');
                    console.log('response', JSON.stringify(response.data))
                } else {
                    console.log('response', JSON.stringify(response.data))
                }    
            } else {
                console.log('response', JSON.stringify(response.data))
            }
        } else {    
            console.log('WARNING: serverPost responed back status code:', JSON.stringify(response.data));
        }    
        // alert('serverPost: Successful post and response is:' + JSON.stringify(response.data) + ' to url:' + url)
        handleReply(response.data);
    })
    .catch((e) => {
        alert('serverPost: Falied to post data:' + JSON.stringify(data) + ' to url:' + url + ' and e.message:' + e)
        console.log('ERROR: Failed in function serverPost for url ', url);
        console.log('Error message:', e); // Error
        handleReply({status:'ERROR', data,  message:e});
    });
}

export default serverPost;

